var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "outputsvg",
    className: "img-fluid",
    viewBox: "0 0 4500 4500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4500,
    height: 4500,
    ry: 1053.2,
    fill: "#ff1331",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 303.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "p1FT2q3EIS",
    d: "m742.48 3041.5 759.27-775.88-758.26-778.94-1.0151-748.39h745.06l773.49 763.66 770.44-763.66h756.23v743.29s-765.75 782.36-769.43 781.99l769.43 780.97v748.39l-746.08-1.0183-780.59-773.84-773.49 774.86h-745.06zm1576.2-773.49 1381-1439.3s-983.13 937.7-1436.6 1377.2l-1444.5-1391.3 1381.6 1447.1-1347.3 1431.4 1405.1-1367.7 1422.7 1367.4z",
    fill: "#fff",
    strokeWidth: 1.1949
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisx);
export default __webpack_public_path__ + "static/media/visx.7b4173aa9fe96e93f0ded12b35ca522d.svg";
export { ForwardRef as ReactComponent };